export default __webpack_public_path__ + "static/media/warning--double-curve-first-right--g2.0c1c9b73.png";